import './infografica.scss';

import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';

const COMPONENT_NAME = 'infografica';

const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_SHOW_MORE: 'infografica__show-more',
  MODIFIER_EXPANDED: 'infografica--expanded',
};

/**
 * version    1.0
 * class      <type> (Infografica)
 */
export class Infografica {
  constructor($container = $('body')) {
    const self = this;

    // find elements
    this._els = {};
    this._els.container = $container;
    this._els.infografica = this._els.container.find(`.${BEM.BLOCK}`);

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.infografica.each(function () {
        self._initSingleInstance($(this));
        TextColorCheck._checkBackground($(this));
      });
    });
  }

  // private methods

  _initSingleInstance($instanceEl) {
    $instanceEl.find(`.${BEM.ELEMENT_SHOW_MORE}`).on('click', () => {
      this._expand($instanceEl);
    });
  }

  _expand($instanceEl) {
    $instanceEl.addClass(BEM.MODIFIER_EXPANDED);
  }
}
